import * as React from 'react';
import { useState, useEffect } from 'react';
import {
  Cell,
  Title,
  MainTitle,
  TableCell,
  Content,
  SeeDetails,
  CellSmall,
  ButtonWrapper
} from './styled';

import { STATE_COLOR } from './constants';
import { Table, TableResponsive } from '@app/src/components/Table';
import { PaginationContainer as Pagination } from './../Pagination';
import * as selectFilterValues from '@app/src/views/CipReport/report/state/filterValues/selectors';
import { ModalContainer } from './../Modal';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';

export const Container: React.FC<any> = ({
  url,
  items = [],
  isFetching,
  filter,
  handleClickModal,
  handleFetchDetail,
  selectedItemDetail,
  message
}) => {
  const [ showResponsive, setShowResponsive ] = useState(true);
  const [ showDetailModal, setShowDetailModal ] = useState(false);

  useEffect(() => {
    window.innerWidth >= 1280 ? setShowResponsive(false) : setShowResponsive(true);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  const handleResize = () => {
    window.innerWidth >= 1280 ? setShowResponsive(false) : setShowResponsive(true);
  };

  let isAdmin = decodeAccessToken('isAdmin');

  useEffect(() => {
    handleFetchDetail({
      ...filter,
      page: 1,
      userId: selectFilterValues.getIdUser(),
      dateStart: selectFilterValues.getStartDate()
    }, url);
  }, []);

  const handleClick = (index) => {
    setShowDetailModal(true)
    handleClickModal();
    selectedItemDetail(index);
  };

  return(
    <>
      {showResponsive ? (
        <TableResponsive data-test="reportTable">
          <TableResponsive.Header data-test="reportTableHeader">
            <MainTitle left>N° CIP</MainTitle>
            <MainTitle center>Estado</MainTitle>
            <MainTitle right>Importe</MainTitle>
          </TableResponsive.Header>
          {(items.length === 0 && !isFetching) ? (
            <TableResponsive.Body>
              <TableResponsive.Main>
                <Content>No se encontraron resultados</Content>
              </TableResponsive.Main>
            </TableResponsive.Body>) : items.map((item, index) => (
            <TableResponsive.Body data-test="reportTableRow" key={index}>
              <TableResponsive.Main>
                <MainTitle left>{item.cip}</MainTitle>
                <MainTitle variant={STATE_COLOR[item.idState]} center>{item.state}</MainTitle>
                <MainTitle right>{item.amount}</MainTitle>
              </TableResponsive.Main>
              <TableResponsive.Content
                renderComponent={<ButtonWrapper onClick={() => handleClick(index)}><SeeDetails name="file-text" color="black" size="16px" />
                Ver Detalle</ButtonWrapper>}>
                <Cell>
                  <Title>Nombre</Title>
                  {item.name} {item.lastName}
                </Cell>
                <Cell>
                  <Title>Nº Documento</Title>
                  {item.documentNumber}
                </Cell>
                <Cell>
                  <Title>F. Generación</Title>
                  {item.generationDate}
                </Cell>
                <Cell>
                  <Title>F. Expiración</Title>
                  {item.expirationDate}
                </Cell>
                <Cell>
                  <Title>F. Pago</Title>
                  {item.paymentDate}
                </Cell>
                <Cell>
                  <Title>Moneda</Title>
                  {item.currency}
                </Cell>
                <Cell>
                  <Title>Nº Pedido</Title>
                  {item.requestNumber}
                  </Cell>
                <Cell>
                  <Title>Tipo Pago</Title>
                  {item.paymentTypeName}
                </Cell>
                {isAdmin && (
                  <Cell>
                    <Title>Operador</Title>
                    {item.operatorName} {item.operatorLastName}
                  </Cell>
                )}
              </TableResponsive.Content>
            </TableResponsive.Body>
          ))}
        </TableResponsive>
      ) : (
        <Table data-test="reportTable">
          <Table.Head data-test="reportTableHeader">
            <Table.Row>
              <Table.Cell>N° CIP</Table.Cell>
              <Table.Cell>Estado</Table.Cell>
              <Table.Cell>F. Generación</Table.Cell>
              <Table.Cell>F. Expiración</Table.Cell>
              <Table.Cell>F. Pago</Table.Cell>
              <Table.Cell>Moneda</Table.Cell>
              <Table.Cell>Importe</Table.Cell>
              <Table.Cell>Nº Documento</Table.Cell>
              <Table.Cell>Nombre</Table.Cell>
              <Table.Cell>Nº Pedido</Table.Cell>
              <Table.Cell>Tipo Pago</Table.Cell>
              { isAdmin && <Table.Cell>Operador</Table.Cell> }
              <Table.Cell />
            </Table.Row>
          </Table.Head>
          <Table.Body>
          {(items.length === 0 && !isFetching) ? (
            <Table.Row data-test="reportTableRow">
              <Content>No se encontraron resultados</Content>
            </Table.Row>) : items.map((item, index) => (
            <Table.Row key={index} data-test="reportTableRow">
              <Table.Cell>{item.cip}</Table.Cell>
              <TableCell variant={STATE_COLOR[item.idState]}>{item.state}</TableCell>
              <Table.Cell>
                <CellSmall>
                  {item.generationDate}
                </CellSmall>
              </Table.Cell>
              <Table.Cell>
                <CellSmall>
                  {item.expirationDate}
                </CellSmall>
              </Table.Cell>
              <Table.Cell>
                <CellSmall>
                  {item.paymentDate}
                </CellSmall>
              </Table.Cell>
              <Table.Cell>{item.currency}</Table.Cell>
              <Table.Cell>{item.amount}</Table.Cell>
              <Table.Cell>{item.documentNumber}</Table.Cell>
              <Table.Cell>
                {item.name}
                <br/>
                {item.lastName}
              </Table.Cell>
              <Table.Cell>{item.requestNumber}</Table.Cell>
              <Table.Cell>{item.paymentTypeName}</Table.Cell>
              {isAdmin && <Table.Cell>{item.operatorName}<br/>{item.operatorLastName}</Table.Cell>}
              <Table.Cell>
                <SeeDetails data-test="reportTableRowDetail" name="file-text" color="black" size="16px" onClick={() => handleClick(index)} />
              </Table.Cell>
            </Table.Row>
          ))}
          </Table.Body>
        </Table>
      )}
      {showDetailModal &&
        <ModalContainer data-test="modal" message={message} closeModal={() => setShowDetailModal(false)} />
      }
      <Pagination url={url}/>
    </>
  );
}
